import { Badge, BadgeProps } from "@minuthq/meatball-ui-react"

import { useTranslate } from "src/i18n/useTranslate"

export function DeviceStatusBadge({
  online,
  badgeProps,
}: {
  online: boolean
  badgeProps?: Omit<BadgeProps, "children">
}) {
  const { t, langKeys } = useTranslate()

  const color = online ? "good" : "error"

  const label = online
    ? t(langKeys.sensor_status_online)
    : t(langKeys.sensor_status_offline)

  return (
    <Badge color={color} size="medium" {...badgeProps}>
      <div>{label}</div>
    </Badge>
  )
}
